/* eslint-disable max-len */
import { Icon } from '@kinesis/bungle';

const AssembleIcon = () => (
  <Icon type='custom' magnitude='medium'>
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.9375 2.8125H13.125V4.14062H11.9531V5H10.625V3.125C10.625 2.95312 10.7656 2.8125 10.9375 2.8125Z'
        fill='white'
        fillOpacity='0.85'
      />
      <path
        d='M10.625 6.875V9.0625C10.625 9.23438 10.7656 9.375 10.9375 9.375H13.125V8.04688H11.9531V6.875H10.625Z'
        fill='white'
        fillOpacity='0.85'
      />
      <path
        d='M16.875 9.375H15V8.04688H15.8594V6.875H17.1875V9.0625C17.1875 9.23438 17.0469 9.375 16.875 9.375Z'
        fill='white'
        fillOpacity='0.85'
      />
      <path
        d='M17.1875 5H15.8594V4.14062H15V2.8125H16.875C17.0469 2.8125 17.1875 2.95312 17.1875 3.125V5Z'
        fill='white'
        fillOpacity='0.85'
      />
      <path
        d='M9.0625 10.625H3.125C2.95312 10.625 2.8125 10.7656 2.8125 10.9375V16.875C2.8125 17.0469 2.95312 17.1875 3.125 17.1875H9.0625C9.23438 17.1875 9.375 17.0469 9.375 16.875V10.9375C9.375 10.7656 9.23438 10.625 9.0625 10.625Z'
        fill='white'
        fillOpacity='0.85'
      />
      <path
        d='M9.0625 2.8125H3.125C2.95312 2.8125 2.8125 2.95312 2.8125 3.125V9.0625C2.8125 9.23438 2.95312 9.375 3.125 9.375H9.0625C9.23438 9.375 9.375 9.23438 9.375 9.0625V3.125C9.375 2.95312 9.23438 2.8125 9.0625 2.8125Z'
        fill='white'
        fillOpacity='0.85'
      />
      <path
        d='M16.875 10.625H10.9375C10.7656 10.625 10.625 10.7656 10.625 10.9375V16.875C10.625 17.0469 10.7656 17.1875 10.9375 17.1875H16.875C17.0469 17.1875 17.1875 17.0469 17.1875 16.875V10.9375C17.1875 10.7656 17.0469 10.625 16.875 10.625Z'
        fill='white'
        fillOpacity='0.85'
      />
    </svg>
  </Icon>
);

export { AssembleIcon };
